import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'block',
    color: 'inherit',
    fontSize: '0.9rem',
    fontWeight: 400,
    marginBottom: 4,
    position: 'relative',
    top: -3,
  },
}));

const FormSpacedLabel = ({ children = '', className = '' }) => {
  const classes = useStyles();

  return <label className={`${classes.root} ${className}`}>{children}</label>;
};

export default FormSpacedLabel;
